import React from 'react';
import SocialHub from '../social/SocialHub';

interface MemberSocialProps {
    memberData?: any;
}

const MemberSocial: React.FC<MemberSocialProps> = ({ memberData }) => {
    const memberId = memberData?.id || 'member-id-placeholder';

    return (
        <div className="min-h-screen bg-gray-50">
            <SocialHub memberId={memberId} />
        </div>
    );
};

export default MemberSocial;